$(function() {
  $('.childTabs a').on('click', function(e) {
    var tab, tabContainer, tabTarget, tabs, tabsContent;
    e.preventDefault();
    tab = $(this);
    tabContainer = tab.parents('.content').first();
    tabs = tabContainer.find('.childTabs dd');
    tabsContent = tabContainer.find('.childTabContent');
    tabTarget = tab.attr('href');
    History.pushState({}, tab.data('title') + ' | Ålandsbanken', tab.data('url'));
    tabs.removeClass('active');
    tab.parent().addClass('active');
    tabsContent.removeClass('active');
    $(tabTarget).addClass('active');
    return false;
  });
  return $('.tabs').on('toggled', function(event, tab) {
    var $targetContent;
    $targetContent = $(tab.find('a').attr('href'));
    if ($targetContent.hasClass('tabWithChildTabs')) {
      $targetContent.find('.childTabs dd').removeClass('active');
      $targetContent.find('.childTabContent').removeClass('active');
      if (($targetContent.find('.parentTabContent').length)) {
        return $targetContent.find('.parentTabContent').addClass('active');
      } else {
        $targetContent.find('.childTabs dd').first().addClass('active');
        return $targetContent.find('.childTabContent').first().addClass('active');
      }
    }
  });
});

// ---
// generated by coffee-script 1.9.2